export const ACTIONS_IMPORT_DATA = {
  INVALIDATE: 'IMPORT_DATA_INVALIDATE',
  RECEIVE: 'IMPORT_DATA_RECEIVE',
  TEMPLATE: 'IMPORT_DATA_TEMPLATE',
  DELETE: 'IMPORT_DATA_DELETE_ROW',
  RECEIVE_ENTITIES: 'IMPORT_DATA_RECEIVE_ENTITIES',
};
